import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "grid-svg",
  templateUrl: "./grid.component.svg",
  styleUrls: ["./grid.component.scss"],
})
export class GridSvgComponent {
  @Input() width: number;

  @HostBinding('style.width') get _width() {
    return this.width ? this.width + 'px' : '';
  }

  @Input() height: number;

  @HostBinding('style.height') get _height() {
    return this.height ? this.height + 'px' : '';
  }
}
